module.exports = __webpack_public_path__ + "img/img_82837_0_1.91aed702.png";